import { render, staticRenderFns } from "./QuestionFace.vue?vue&type=template&id=dd35f49e&scoped=true"
import script from "./QuestionFace.vue?vue&type=script&lang=js"
export * from "./QuestionFace.vue?vue&type=script&lang=js"
import style0 from "./QuestionFace.vue?vue&type=style&index=0&id=dd35f49e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd35f49e",
  null
  
)

export default component.exports